import React, { Component } from 'react';
import cn from 'classnames';
import {
  preloadMathJaxWithLearnosity,
  setMathJaxTypeset,
} from 'chameleon/src/utility/utils';

import defer from 'lodash/defer';
import { viewed } from '../shared/status';

import './math.scss';

class Player extends Component {
  componentDidMount() {
    preloadMathJaxWithLearnosity();
  }

  render() {
    const { alt, math } = this.props.item.content;
    const wrapperProps = {
      className: cn('math'),
      ref: (r) => {
        if (r) {
          this._domNode = r;
          return r;
        }
      },
      role: 'math',
      'aria-label': alt,
    };

    defer(() => wrapperProps.ref?.() && setMathJaxTypeset(wrapperProps.ref()));
    wrapperProps.dangerouslySetInnerHTML = { __html: math };
    return <span {...wrapperProps} data-am-type="media/math" />;
  }
}

Player.displayName = 'Math';

export default { Player, status: viewed };
